"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CleanRow = exports.spaceTest = exports.testData = exports.AssembleGridContainerMonthData = exports.AssembleGridContainerWeekData = exports.AssembleGridContainerData = exports.trafficSpaceGridMockWithConflics = exports.trafficSpaceGridMockWithoutData = exports.trafficSpaceGridMock = exports.trafficSpacesRowMock = exports.shipmentDetailMock = exports.shipmentCardMock = exports.mockItemsData = void 0;

var _react = _interopRequireDefault(require("react"));

var _ref;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mockItemsData = [{
  TruckNumber: 'TZ-380',
  companyLogo: 'http://3.bp.blogspot.com/-foIIfWQuop4/T7jS7XjntOI/AAAAAAAAJRc/np4ldDAieUM/s1920/pickup-truck-hd-wallpaper-5.jpg',
  icon: 'http://www.free-icons-download.net/images/truck-icon-53598.png',
  tripNumber: '48205'
}, {
  TruckNumber: 'TZ-380',
  companyLogo: 'http://3.bp.blogspot.com/-foIIfWQuop4/T7jS7XjntOI/AAAAAAAAJRc/np4ldDAieUM/s1920/pickup-truck-hd-wallpaper-5.jpg',
  icon: 'http://www.free-icons-download.net/images/truck-icon-53598.png',
  tripNumber: '48205'
}, {
  TruckNumber: 'TZ-380',
  companyLogo: 'http://3.bp.blogspot.com/-foIIfWQuop4/T7jS7XjntOI/AAAAAAAAJRc/np4ldDAieUM/s1920/pickup-truck-hd-wallpaper-5.jpg',
  icon: 'http://www.free-icons-download.net/images/truck-icon-53598.png',
  tripNumber: '48205'
}, {
  TruckNumber: 'TZ-380',
  companyLogo: 'http://3.bp.blogspot.com/-foIIfWQuop4/T7jS7XjntOI/AAAAAAAAJRc/np4ldDAieUM/s1920/pickup-truck-hd-wallpaper-5.jpg',
  icon: 'http://www.free-icons-download.net/images/truck-icon-53598.png',
  tripNumber: '48205'
}, {
  TruckNumber: 'TZ-380',
  companyLogo: 'http://3.bp.blogspot.com/-foIIfWQuop4/T7jS7XjntOI/AAAAAAAAJRc/np4ldDAieUM/s1920/pickup-truck-hd-wallpaper-5.jpg',
  icon: 'http://www.free-icons-download.net/images/truck-icon-53598.png',
  tripNumber: '48205'
}, {
  TruckNumber: 'TZ-380',
  companyLogo: 'http://3.bp.blogspot.com/-foIIfWQuop4/T7jS7XjntOI/AAAAAAAAJRc/np4ldDAieUM/s1920/pickup-truck-hd-wallpaper-5.jpg',
  icon: 'http://www.free-icons-download.net/images/truck-icon-53598.png',
  tripNumber: '48205'
}, {
  TruckNumber: 'TZ-380',
  companyLogo: 'http://3.bp.blogspot.com/-foIIfWQuop4/T7jS7XjntOI/AAAAAAAAJRc/np4ldDAieUM/s1920/pickup-truck-hd-wallpaper-5.jpg',
  icon: 'http://www.free-icons-download.net/images/truck-icon-53598.png',
  tripNumber: '48205'
}, {
  TruckNumber: 'TZ-380',
  companyLogo: 'http://3.bp.blogspot.com/-foIIfWQuop4/T7jS7XjntOI/AAAAAAAAJRc/np4ldDAieUM/s1920/pickup-truck-hd-wallpaper-5.jpg',
  icon: 'http://www.free-icons-download.net/images/truck-icon-53598.png',
  tripNumber: '48205'
}];
exports.mockItemsData = mockItemsData;
var shipmentCardMock = [{
  id: 1,
  className: '',
  shipment: '48207',
  tickets: [{
    id: 15,
    number: '12345680',
    companyLogo: 'https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png',
    courierLogo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJzX6LS9PXB3EGYwyIIIig1n6W4PPZMDU6YCtiPoYQVVJ8ZmAMOw&s',
    status: 'ffffff',
    level: 4,
    location: 'VER MX',
    datetime: '12	Jun	/	12: 05',
    expeditionClass: 'ABCD',
    tags: [{
      id: '90',
      description: 'ZGFH'
    }, {
      id: '91',
      description: 'Doméstico'
    }, {
      id: '93',
      description: 'Etiqueta 3'
    }],
    maneuverIcon: /*#__PURE__*/_react["default"].createElement("img", {
      src: "https://img2.freepng.es/20180329/efq/kisspng-computer-icons-raw-material-building-materials-material-5abdae8a633484.0599203215223804264064.jpg",
      alt: "",
      style: {
        width: '100%',
        height: '100%'
      }
    })
  }]
}, {
  id: 2,
  className: '',
  shipment: '48207',
  tickets: [{
    id: 16,
    number: '12345680',
    companyLogo: 'https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png',
    courierLogo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJzX6LS9PXB3EGYwyIIIig1n6W4PPZMDU6YCtiPoYQVVJ8ZmAMOw&s',
    status: 'ffffff',
    level: 4,
    location: 'VER MX',
    datetime: '12	Jun	/	12: 05',
    expeditionClass: 'ABCD',
    tags: [{
      id: '90',
      description: 'ZGFH'
    }, {
      id: '91',
      description: 'Doméstico'
    }, {
      id: '93',
      description: 'Etiqueta 3'
    }],
    maneuverIcon: /*#__PURE__*/_react["default"].createElement("img", {
      src: "https://img2.freepng.es/20180329/efq/kisspng-computer-icons-raw-material-building-materials-material-5abdae8a633484.0599203215223804264064.jpg",
      alt: "",
      style: {
        width: '100%',
        height: '100%'
      }
    })
  }]
}, {
  id: 3,
  className: '',
  shipment: '48207',
  tickets: [{
    id: 16,
    number: '12345680',
    companyLogo: 'https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png',
    courierLogo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJzX6LS9PXB3EGYwyIIIig1n6W4PPZMDU6YCtiPoYQVVJ8ZmAMOw&s',
    status: 'ffffff',
    level: 4,
    location: 'VER MX',
    datetime: '12	Jun	/	12: 05',
    expeditionClass: 'ABCD',
    tags: [{
      id: '94',
      description: 'Etiqueta 1'
    }],
    maneuverIcon: /*#__PURE__*/_react["default"].createElement("img", {
      src: "",
      alt: ""
    })
  }, {
    id: 17,
    number: '12345680',
    companyLogo: 'https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png',
    courierLogo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJzX6LS9PXB3EGYwyIIIig1n6W4PPZMDU6YCtiPoYQVVJ8ZmAMOw&s',
    status: 'ffffff',
    level: 4,
    location: 'VER MX',
    datetime: '12	Jun	/	12: 05',
    expeditionClass: 'ABCD',
    tags: [{
      id: '95',
      description: 'Etiqueta 1'
    }],
    maneuverIcon: /*#__PURE__*/_react["default"].createElement("img", {
      src: "",
      alt: ""
    })
  }]
}];
exports.shipmentCardMock = shipmentCardMock;
var shipmentDetailMock = {
  id: 1,
  number: '456712987',
  status: {
    id: 2,
    description: 'Viaje atendido CON UN MONTON DE INFORMACION',
    color: '#70889E',
    fontColor: 'red'
  },
  expeditionClass: 'ZE00',
  expeditionClassIcon: '👽',
  alertIcon: '👽',
  courier: {
    logo: 'https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png',
    name: 'Transportes del norte del sur al oeste del este',
    vehicleIcon: '👽',
    equipmentIcon: '👽',
    operatorIcon: '👽',
    vehicle: {
      id: 124,
      number: 'TI763'
    },
    equipment: [{
      id: 83,
      number: 'HR539'
    }, {
      id: 96,
      number: 'HF976'
    }],
    operator: [{
      id: 52,
      name: 'Manuel martinez'
    }, {
      id: 5,
      name: 'martinez, courier'
    }]
  },
  tickets: [{
    id: 65,
    detailButton: 'lol',
    number: '45663586',
    origin: {
      companyLogo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/ITunes_12.2_logo.png/600px-ITunes_12.2_logo.png',
      location: 'VER, MX',
      timedate: '20:23 / 2 Jul 19',
      eta: '2021-03-18T04:00:00-06:00',
      ata: ''
    },
    destination: {
      companyLogo: 'https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png',
      location: 'INSTALACION GENERICAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOOO',
      timedate: '12:00 / 3 Jul 19',
      eta: '',
      ata: '2018-03-18T04:00:00-06:00'
    },
    level: 3,
    weight: 20,
    volume: 1203,
    capacity: 120.0,
    weightIcon: '👽',
    volumeIcon: '👽',
    capacityIcon: '👽',
    tags: [{
      id: 12,
      description: 'Etiqueta 12'
    }, {
      id: 21,
      description: 'Etiqueta 21'
    }],
    status: [{
      icon: '👽',
      trailer: 'R123',
      name: 'Entrada origen'
    }, {
      icon: '👽',
      trailer: 'R124',
      name: 'Entrada origen'
    }],
    notificationCenter: [{
      alert: 'Alerta de estadía de carga/descarga prolongada (ATCT).',
      level: 5
    }],
    containers: [{
      ata_loading: null,
      ata_unloading: null,
      eta_loading: '2021-03-18T04:00:00-06:00',
      eta_unloading: '2022-03-18T09:00:00-06:00'
    }, {
      ata_loading: null,
      ata_unloading: '2021-03-18T09:00:00-06:00',
      eta_loading: '2021-03-18T09:00:00-06:00',
      eta_unloading: null
    }]
  }, {
    id: 66,
    detailButton: 'lol',
    number: '45663587',
    origin: {
      companyLogo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/ITunes_12.2_logo.png/600px-ITunes_12.2_logo.png',
      location: 'VER, MX',
      timedate: '20:23 / 2 Jul 19'
    },
    destination: {
      companyLogo: 'https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png',
      location: 'MTY, MX',
      timedate: '12:00 / 3 Jul 19'
    },
    level: 3,
    weight: 20,
    volume: 1203,
    capacity: 120.0,
    tags: [{
      id: 12,
      description: 'Etiqueta 12'
    }, {
      id: 21,
      description: 'Etiqueta 21'
    }],
    notificationCenter: [{
      alert: 'Alerta de viaje iniciado',
      level: 5
    }]
  }, {
    detailButton: 'lol',
    id: 67,
    number: '45663588',
    origin: {
      companyLogo: 'https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png',
      location: 'MID, MX',
      timedate: '20:23 / 2 Jul 19'
    },
    destination: {
      companyLogo: 'https://icon2.cleanpng.com/20171220/gze/twitter-logo-png-5a3a1851372e76.0876249315137567532269680.jpg',
      location: 'CD, MX',
      timedate: '12:00 / 3 Jul 19'
    },
    level: 3,
    weight: 20,
    volume: 1203,
    capacity: 120.0,
    tags: [{
      id: 12,
      description: 'Etiqueta 12'
    }, {
      id: 21,
      description: 'Etiqueta 21'
    }]
  }],
  actions: [{
    caption: 'Cancelar cita',
    onAction: function onAction() {}
  }, {
    caption: 'Cancelar reservación',
    onAction: function onAction() {}
  }],
  onClose: function onClose() {},
  primary: {
    caption: 'Cancelar reservación',
    onClick: function onClick() {},
    type: 'primary'
  },
  secondary: {
    caption: 'Cancelar',
    onClick: function onClick() {},
    type: 'outline'
  }
};
/**
 * #336741
 * #09C985
 * #F4797D
 * #8B95A6
 */

exports.shipmentDetailMock = shipmentDetailMock;
var trafficSpacesRowMock = [{
  id: 1,
  icon: '👽',
  expClass: 'D',
  level: 1,
  begin: 700,
  end: 800,
  className: null,
  color: '#336741',
  onClick: function onClick() {}
}, {
  id: 2,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 800,
  end: 900,
  className: null,
  color: '#336741',
  onClick: function onClick() {}
}, {
  id: 3,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 900,
  end: 930,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 4,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 930,
  end: 1000,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 5,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1000,
  end: 1030,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 6,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1030,
  end: 1100,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 7,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1100,
  end: 1200,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 8,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1200,
  end: 1300,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 9,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1300,
  end: 1400,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 10,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1400,
  end: 1430,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 11,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1600,
  end: 1630,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 11,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1630,
  end: 1700,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 12,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1700,
  end: 1730,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 13,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1730,
  end: 1800,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 13,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1800,
  end: 1830,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 13,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1830,
  end: 1900,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}];
exports.trafficSpacesRowMock = trafficSpacesRowMock;
var trafficSpacesRowTwoMock = [{
  id: 1,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 600,
  end: 630,
  className: null,
  color: '#336741',
  onClick: function onClick() {}
}, {
  id: 2,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 630,
  end: 700,
  className: null,
  color: '#336741',
  onClick: function onClick() {}
}, {
  id: 3,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 700,
  end: 800,
  className: null,
  color: '#336741',
  onClick: function onClick() {}
}, {
  id: 4,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 900,
  end: 1000,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 5,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1000,
  end: 1100,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 6,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1100,
  end: 1200,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 7,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1200,
  end: 1300,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 8,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1400,
  end: 1500,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 9,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1500,
  end: 1600,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 10,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1600,
  end: 1700,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}];
var trafficSpacesRowThreeMock = [{
  id: 1,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 700,
  end: 800,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 2,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 800,
  end: 900,
  className: null,
  color: '#336741',
  onClick: function onClick() {}
}, {
  id: 3,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 900,
  end: 930,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 4,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 930,
  end: 1000,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 5,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1000,
  end: 1100,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 6,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1100,
  end: 1130,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 7,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1130,
  end: 1200,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 8,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1200,
  end: 1300,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 9,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1300,
  end: 1400,
  className: null,
  color: '#8B95A6',
  onClick: function onClick() {}
}, {
  id: 10,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1400,
  end: 1500,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 11,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1500,
  end: 1600,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 2,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1600,
  end: 1700,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}];
var trafficSpacesRowFourMock = [{
  id: 1,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 730,
  end: 840,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 2,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 840,
  end: 930,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 3,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 930,
  end: 1015,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 4,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1015,
  end: 1100,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 5,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1100,
  end: 1130,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 6,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1130,
  end: 1200,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 7,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1300,
  end: 1400,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 8,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1400,
  end: 1500,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 9,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1500,
  end: 1530,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}];
var trafficSpacesRowFiveMock = [{
  id: 1,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1030,
  end: 1100,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 2,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1100,
  end: 1130,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 3,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1130,
  end: 1200,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 4,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1300,
  end: 1400,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 5,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1400,
  end: 1500,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 6,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1500,
  end: 1530,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 7,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1530,
  end: 1600,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 8,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1600,
  end: 1700,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 9,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1700,
  end: 1800,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 10,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1800,
  end: 1900,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 11,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1900,
  end: 2000,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}];
var trafficSpacesRowSixMock = [{
  id: 1,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 700,
  end: 800,
  className: null,
  color: '#336741',
  onClick: function onClick() {}
}, {
  id: 2,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 900,
  end: 1000,
  className: null,
  color: '#F4797D',
  onClick: function onClick() {}
}, {
  id: 3,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1100,
  end: 1200,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 3,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1300,
  end: 1330,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 4,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1330,
  end: 1400,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 5,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1400,
  end: 1430,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 6,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1430,
  end: 1500,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 7,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1500,
  end: 1600,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 8,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1600,
  end: 1700,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 9,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1700,
  end: 1800,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}, {
  id: 10,
  icon: '👽',
  expClass: null,
  level: 1,
  begin: 1800,
  end: 1900,
  className: null,
  color: '#09C985',
  onClick: function onClick() {}
}];
var appointmentConflicRowOne = [{
  icon: '👽',
  begin: 1430,
  end: 1600,
  className: null,
  caption: '3 citas \nen \nconflicto',
  onClick: function onClick() {},
  conflictingIds: [15, 16],
  color: null
}];
var appointmentConflicRowTwo = [{
  icon: '👽',
  begin: 800,
  end: 900,
  className: null,
  caption: '8 citas \nen \nconflicto',
  onClick: function onClick() {},
  conflictingIds: [15, 16],
  color: null
}, {
  icon: '👽',
  begin: 1300,
  end: 1400,
  className: null,
  caption: '2 citas \nen \nconflicto',
  onClick: function onClick() {},
  conflictingIds: [15, 16],
  color: null
}];
var appointmentConflicRowFour = [{
  icon: '👽',
  begin: 1530,
  end: 1900,
  className: null,
  caption: '9 citas \nen \nconflicto',
  onClick: function onClick() {},
  conflictingIds: [15, 16],
  color: null
}];
var appointmentConflicRowFive = [{
  icon: '👽',
  begin: 800,
  end: 1030,
  className: null,
  caption: '4 citas \nen \nconflicto',
  onClick: function onClick() {},
  conflictingIds: [15, 16],
  color: null
}];
var trafficSpaceGridMock = {
  begin: 800,
  end: 1800,
  spaces: [{
    id: 1,
    rowIndex: 1,
    loadManeuver: true,
    loadManeuverIcon: '💀',
    begin: 800,
    end: 1500,
    tags: [// {
      //   id: 90,
      //   description: 'Domésticos',
      //   color: 'pink'
      // },
      // {
      //   id: 91,
      //   description: 'Doméstico',
      //   color: 'blue'
      // },
      // {
      //   id: 93,
      //   description: 'Etiqueta 3',
      //   color: 'red'
      // }
    ],
    appointments: trafficSpacesRowMock // className: 'space-grid-height'

  } // {
  //   id: 2,
  //   rowIndex: 2,
  //   loadManeuver: true,
  //   loadManeuverIcon: '💀',
  //   begin: 600,
  //   end: 1700,
  //   tags: [
  //     {
  //       id: 90,
  //       description: 'Domésticos',
  //       color: 'pink'
  //     }
  //   ],
  //   appointments: trafficSpacesRowTwoMock
  //   // className: 'space-grid-height'
  // },
  // {
  //   id: 3,
  //   loadManeuver: true,
  //   loadManeuverIcon: '💀',
  //   begin: 700,
  //   end: 1800,
  //   tags: [
  //     {
  //       id: 90,
  //       description: 'Exportación',
  //       color: '#FF9144'
  //     },
  //     {
  //       id: 91,
  //       description: 'Doméstico',
  //       color: 'blue'
  //     },
  //     {
  //       id: 92,
  //       description: 'Etiqueta 3',
  //       color: 'red'
  //     }
  //   ],
  //   appointments: trafficSpacesRowThreeMock
  //   // className: 'space-grid-height'
  // },
  // {
  //   id: 4,
  //   loadManeuver: true,
  //   loadManeuverIcon: '💀',
  //   begin: 700,
  //   end: 1900,
  //   tags: [
  //     {
  //       id: 90,
  //       description: 'Exportación',
  //       color: '#FF9144'
  //     },
  //     {
  //       id: 91,
  //       description: 'Doméstico',
  //       color: 'blue'
  //     },
  //     {
  //       id: 92,
  //       description: 'Etiqueta 3',
  //       color: 'red'
  //     }
  //   ],
  //   appointments: trafficSpacesRowFourMock
  //   // className: 'space-grid-height'
  // },
  // {
  //   id: 5,
  //   loadManeuver: true,
  //   loadManeuverIcon: '💀',
  //   begin: 800,
  //   end: 1900,
  //   tags: [
  //     {
  //       id: 90,
  //       description: 'Exportación',
  //       color: '#FF9144'
  //     }
  //   ],
  //   appointments: trafficSpacesRowFiveMock
  //   // className: 'space-grid-height'
  // },
  // {
  //   id: 6,
  //   loadManeuver: true,
  //   loadManeuverIcon: '💀',
  //   begin: 700,
  //   end: 1900,
  //   tags: [
  //     {
  //       id: 90,
  //       description: 'Exportación',
  //       color: '#FF9144'
  //     }
  //   ],
  //   appointments: trafficSpacesRowSixMock
  //   // className: 'space-grid-height'
  // }
  ]
};
exports.trafficSpaceGridMock = trafficSpaceGridMock;
var trafficSpaceGridMockWithoutData = {
  begin: 600,
  end: 1900,
  spaces: [{
    id: 1,
    loadManeuver: true,
    loadManeuverIcon: '💀',
    begin: 700,
    end: 1800,
    tags: [{
      id: 90,
      description: 'Exportación',
      color: '#FF9144'
    }],
    appointments: [],
    windows: [],
    conflicts: [] // className: 'space-grid-height'

  }, {
    id: 2,
    loadManeuver: true,
    loadManeuverIcon: '💀',
    begin: 600,
    end: 1600,
    tags: [{
      id: 90,
      description: 'Exportación',
      color: '#FF9144'
    }],
    appointments: [],
    windows: [],
    conflicts: [] // className: 'space-grid-height'

  }, {
    id: 3,
    loadManeuver: true,
    loadManeuverIcon: '💀',
    begin: 700,
    end: 1700,
    tags: [{
      id: 90,
      description: 'Exportación',
      color: '#FF9144'
    }],
    appointments: [],
    windows: [],
    conflicts: [] // className: 'space-grid-height'

  }, {
    id: 4,
    loadManeuver: true,
    loadManeuverIcon: '💀',
    begin: 700,
    end: 1800,
    tags: [{
      id: 90,
      description: 'Exportación',
      color: '#FF9144'
    }],
    appointments: [],
    windows: [],
    conflicts: [] // className: 'space-grid-height'

  }, {
    id: 5,
    loadManeuver: true,
    loadManeuverIcon: '💀',
    begin: 900,
    end: 1900,
    tags: [{
      id: 90,
      description: 'Exportación',
      color: '#FF9144'
    }],
    appointments: [],
    windows: [],
    conflicts: [] // className: 'space-grid-height'

  }, {
    id: 6,
    loadManeuver: true,
    loadManeuverIcon: '💀',
    begin: 700,
    end: 1800,
    tags: [{
      id: 90,
      description: 'Exportación',
      color: '#FF9144'
    }],
    appointments: [],
    windows: [],
    conflicts: [] // className: 'space-grid-height'

  }]
}; // export const trafficSpaceGridMockWithConflics = {
//   // begin: 600,
//   // end: 1900,
//   begin: 0,
//   end: 2300,
//   spaces: [
//     {
//       id: 1,
//       loadManeuver: true,
//       loadManeuverIcon: '💀',
//       // begin: 700,
//       // end: 1900,
//       tags: [
//         {
//           id: 90,
//           description: 'Domésticos',
//           color: 'pink'
//         },
//         {
//           id: 91,
//           description: 'Doméstico',
//           color: 'blue'
//         },
//         {
//           id: 93,
//           description: 'Etiqueta 3',
//           color: 'red'
//         }
//       ],
//       windows: [],
//       appointments: trafficSpacesRowMock,
//       conflicts: appointmentConflicRowOne
//       // conflicts: []
//       // className: 'space-grid-height'
//     },
//     {
//       id: 2,
//       loadManeuver: true,
//       loadManeuverIcon: '💀',
//       // begin: 600,
//       // end: 1700,
//       tags: [
//         {
//           id: 90,
//           description: 'Domésticos',
//           color: 'pink'
//         }
//       ],
//       windows: [],
//       // appointments: trafficSpacesRowTwoMock,
//       // conflicts: appointmentConflicRowTwo
//       appointments: [],
//       conflicts: []
//       // className: 'space-grid-height'
//     },
//     {
//       id: 3,
//       loadManeuver: true,
//       loadManeuverIcon: '💀',
//       // begin: 700,
//       // end: 1800,
//       tags: [
//         {
//           id: 90,
//           description: 'Exportación',
//           color: '#FF9144'
//         },
//         {
//           id: 91,
//           description: 'Doméstico',
//           color: 'blue'
//         },
//         {
//           id: 92,
//           description: 'Etiqueta 3',
//           color: 'red'
//         }
//       ],
//       windows: [],
//       appointments: trafficSpacesRowThreeMock,
//       conflicts: []
//       // className: 'space-grid-height'
//     },
//     {
//       id: 4,
//       loadManeuver: true,
//       loadManeuverIcon: '💀',
//       // begin: 700,
//       // end: 1900,
//       tags: [
//         {
//           id: 90,
//           description: 'Exportación',
//           color: '#FF9144'
//         },
//         {
//           id: 91,
//           description: 'Doméstico',
//           color: 'blue'
//         },
//         {
//           id: 92,
//           description: 'Etiqueta 3',
//           color: 'red'
//         }
//       ],
//       windows: [],
//       // appointments: trafficSpacesRowFourMock,
//       // conflicts: appointmentConflicRowFour
//       appointments: [],
//       conflicts: []
//       // className: 'space-grid-height'
//     },
//     {
//       id: 5,
//       loadManeuver: true,
//       loadManeuverIcon: '💀',
//       // begin: 800,
//       // end: 1900,
//       tags: [
//         {
//           id: 90,
//           description: 'Exportación',
//           color: '#FF9144'
//         }
//       ],
//       windows: [],
//       // appointments: trafficSpacesRowFiveMock,
//       // conflicts: appointmentConflicRowFive
//       appointments: [],
//       conflicts: []
//       // className: 'space-grid-height'
//     },
//     {
//       id: 6,
//       loadManeuver: true,
//       loadManeuverIcon: '💀',
//       // begin: 700,
//       // end: 1900,
//       tags: [
//         {
//           id: 90,
//           description: 'Exportación',
//           color: '#FF9144'
//         }
//       ],
//       windows: [],
//       // appointments: trafficSpacesRowSixMock,
//       // conflicts: []
//       appointments: [],
//       conflicts: []
//       // className: 'space-grid-height'
//     }
//   ]
// }

exports.trafficSpaceGridMockWithoutData = trafficSpaceGridMockWithoutData;
var trafficSpaceGridMockWithConflics = {
  begin: 0,
  end: 2300,
  spaces: [{
    rowIndex: 1,
    id: 1073,
    loadManeuver: true,
    unloadManeuver: true,
    unloadLoadManeuver: true,
    loadManeuverIcon: 'L',
    unloadManeuverIcon: 'U',
    unloadLoadManeuverIcon: 'UL',
    tags: [{
      id: 337,
      description: 'CERVEZA',
      color: '3D77F7'
    }],
    windows: [{
      begin: 0,
      end: 2359
    }],
    appointments: [],
    conflicts: []
  }, {
    rowIndex: 2,
    id: 1163,
    loadManeuver: true,
    unloadManeuver: true,
    unloadLoadManeuver: true,
    loadManeuverIcon: 'L',
    unloadManeuverIcon: 'U',
    unloadLoadManeuverIcon: 'UL',
    tags: [{
      id: 337,
      description: 'CERVEZA',
      color: '3D77F7'
    }],
    windows: [{
      begin: 0,
      end: 2359
    }],
    appointments: [{
      spaceIndex: 1,
      spaceId: 1163,
      statusId: 3,
      id: 19,
      level: null,
      description: '0013581899',
      descriptionText: '001358189911',
      begin: 900,
      fontColor: '#6197F5',
      color: 'white',
      icon: '👽',
      expClass: 'X2',
      end: 1000,
      visible: true,
      tripId: 10,
      fleet_provider: 'Orta',
      op: 'load',
      opIcon: '👽',
      containers: [{
        eta: '',
        ata: '2022-06-14 10:20:00',
        date: ''
      }, {
        eta: '2022-06-14 11:20:00',
        ata: '',
        date: '2022-06-14 10:20:00'
      }]
    }],
    conflicts: [{
      isConflict: true,
      spaceIndex: 2,
      spaceId: 1166,
      statusId: '',
      id: '',
      level: '',
      begin: 30,
      onDrop: '',
      color: 'none',
      fontColor: '#6197F5',
      end: 200,
      visible: true,
      tripId: '9',
      orders: [{
        begin: 30,
        code: '0013585332',
        end: 130,
        expClass: 'X2',
        tripId: 21
      }, {
        begin: 60,
        code: '0013585344',
        end: 200,
        expClass: 'X2',
        tripId: 26,
        fleet_provider: 'Orta',
        icon: '👽',
        containers: [{
          eta: '',
          ata: '',
          date: ''
        }, {
          eta: '2022-06-14 11:20:00',
          ata: '',
          date: '2022-06-14 10:20:00'
        }]
      }, {
        begin: 40,
        code: '0013585333',
        end: 140,
        expClass: 'X2',
        tripId: 21
      } // {
      //   begin: 130,
      //   code: '0013585345',
      //   end: 400,
      //   expClass: 'X2',
      //   tripId: 21
      // }
      ]
    }]
  }, {
    rowIndex: 3,
    id: 1166,
    loadManeuver: true,
    unloadManeuver: true,
    unloadLoadManeuver: true,
    loadManeuverIcon: 'L',
    unloadManeuverIcon: 'U',
    unloadLoadManeuverIcon: 'UL',
    tags: [{
      id: 337,
      description: 'CERVEZA',
      color: '3D77F7'
    }],
    windows: [{
      begin: 0,
      end: 2359
    }],
    appointments: [],
    conflicts: [] // conflicts: [
    //   {
    //     isConflict: true,
    //     spaceIndex: 2,
    //     spaceId: 1166,
    //     statusId: '',
    //     id: '',
    //     level: '',
    //     begin: 30,
    //     onDrop: '',
    //     color: 'none',
    //     fontColor: '#6197F5',
    //     end: 200,
    //     visible: true,
    //     tripId: '9',
    //     orders: [
    //       {
    //         begin: 30,
    //         code: '0013585332',
    //         end: 130,
    //         expClass: 'X2'
    //       },
    //       {
    //         begin: 60,
    //         code: '0013585344',
    //         end: 200,
    //         expClass: 'X2'
    //       },
    //       {
    //         begin: 40,
    //         code: '0013585333',
    //         end: 140,
    //         expClass: 'X2'
    //       },
    //       {
    //         begin: 130,
    //         code: '0013585345',
    //         end: 200,
    //         expClass: 'X2'
    //       }
    //     ]
    //   }
    // ]

  }]
};
exports.trafficSpaceGridMockWithConflics = trafficSpaceGridMockWithConflics;
var AssembleGridContainerData = {
  headerTitle: 'Flotilla',
  columnRangeType: 'DAY',
  columnSections: 8,
  columnQuantity: 7,
  startDatetime: new Date(2020, 3, 25, 9, 0, 0),
  selectItems: [],
  onDivisionSummary: function onDivisionSummary(value) {
    return value;
  }
};
exports.AssembleGridContainerData = AssembleGridContainerData;
var AssembleGridContainerWeekData = {
  headerTitle: 'Flotilla',
  extended: true,
  columnRangeType: 'WEEK',
  columnSections: 7,
  columnQuantity: 4,
  startDatetime: new Date(),
  selectItems: [],
  onDivisionSummary: function onDivisionSummary(value) {
    return value;
  }
};
exports.AssembleGridContainerWeekData = AssembleGridContainerWeekData;
var AssembleGridContainerMonthData = {
  headerTitle: 'Flotilla',
  extended: true,
  columnRangeType: 'MONTH',
  columnSections: 4,
  columnQuantity: 6,
  startDatetime: new Date(),
  selectItems: [],
  onDivisionSummary: function onDivisionSummary(value) {
    return value;
  }
};
exports.AssembleGridContainerMonthData = AssembleGridContainerMonthData;
var testData = {
  begin: 0,
  end: 2300,
  scrollWidth: "2000px",
  dateValidation: -950400000,
  selectedTime: null,
  selectedTimeFormat: null,
  spaces: [(_ref = {
    id: 1127,
    rowIndex: 1,
    loadManeuver: true,
    loadManeuverIcon: '💀',
    unloadLoadManeuver: true,
    unloadLoadManeuverIcon: '💀',
    unloadManeuver: true,
    unloadManeuverIcon: '💀',
    facilityId: 7273,
    tags: [{
      color: '#B84CBE',
      description: 'Ejemplo',
      id: 1934
    }],
    windows: [{
      begin: 0,
      end: 40,
      realBegin: -1,
      realEnd: 40,
      dropOnWindow: function dropOnWindow(a, e, i, o, u) {
        return console.log('drop on window', a, e, i, o, u);
      }
    }, {
      begin: 200,
      end: 300,
      realBegin: 200,
      realEnd: 300,
      dropOnWindow: function dropOnWindow(a, e, i, o, u) {
        return console.log('drop on window', a, e, i, o, u);
      }
    }]
  }, _defineProperty(_ref, "tags", []), _defineProperty(_ref, "appointments", [// {
    //   alert: null,
    //   begin: 2230,
    //   color: 'white',
    //   content: undefined,
    //   description: '68003043668',
    //   descriptionText: '68003043668',
    //   end: 2330,
    //   eta: '2021-03-18T04:00:00-06:00',
    //   expClass: 'X2',
    //   facilityId: 7273,
    //   fleet_provider: 'zemogics',
    //   fontColor: '#6197F5',
    //   icon: '👽',
    //   id: 312268,
    //   level: 1,
    //   onClick: () => {},
    //   onDrop: () => {},
    //   op: 'load',
    //   opIcon: '👽',
    //   plates: 'xxx',
    //   searchTerm: false,
    //   searched: true,
    //   shadow: false,
    //   spaceId: 1127,
    //   spaceIndex: 0,
    //   statusId: 3,
    //   tripId: 185644,
    //   visible: 1,
    //   containers: [
    //     {
    //       eta: '',
    //       ata: '',
    //       date: '2022-11-14 00:10:00'
    //     },
    //     {
    //       eta: '',
    //       ata: '',
    //       date: '2022-11-14 00:10:00'
    //     }
    //   ]
    // },
  ]), _defineProperty(_ref, "conflicts", []), _ref)]
};
exports.testData = testData;
var spaceTest = {
  begin: 0,
  end: 2300,
  spaces: [{
    rowIndex: 1,
    id: 127,
    loadManeuver: true,
    unloadManeuver: true,
    unloadLoadManeuver: true,
    loadManeuverIcon: 'L',
    unloadManeuverIcon: 'U',
    unloadLoadManeuverIcon: 'UL',
    tags: [{
      id: 314,
      color: 'FFA517',
      description: 'DEDICADO'
    }, {
      id: 312,
      color: '3D77F7',
      description: 'CERVEZA'
    } // { id: 315, color: 'EDB8FF', description: 'NO DEDICADO' },
    // { id: 313, color: '05C985', description: 'VIDRIO' }
    ],
    windows: [{
      begin: 0,
      end: 2359
    }],
    appointments: [{
      id: 2792,
      level: null,
      description: '0013410609',
      begin: 530,
      fontColor: '#6197F5',
      color: 'white',
      icon: null,
      end: 630,
      visible: true
    }]
  }, {
    id: 120,
    rowIndex: 100,
    loadManeuver: true,
    unloadManeuver: true,
    unloadLoadManeuver: true,
    loadManeuverIcon: '',
    unloadManeuverIcon: '',
    unloadLoadManeuverIcon: '',
    tags: [{
      id: 314,
      color: 'FFA517',
      description: 'DEDICADO'
    }, {
      id: 312,
      color: '3D77F7',
      description: 'CERVEZA'
    }, {
      id: 315,
      color: 'EDB8FF',
      description: 'NO DEDICADO'
    }, {
      id: 313,
      color: '05C985',
      description: 'VIDRIO'
    }],
    windows: [{
      begin: 0,
      end: 2359
    }],
    appointments: [{
      id: 2794,
      level: null,
      description: '0013410197',
      begin: 1515,
      fontColor: '#6197F5',
      color: 'white',
      icon: null,
      end: 1615,
      visible: true
    }, {
      id: 2792,
      level: null,
      description: '0013410609',
      begin: 2000,
      fontColor: '#6197F5',
      color: 'white',
      icon: null,
      end: 2100,
      visible: true
    }]
  }]
};
exports.spaceTest = spaceTest;
var CleanRow = {
  begin: 0,
  end: 2300,
  spaces: [{
    // rowIndex: 100,
    id: 129,
    loadManeuver: true,
    unloadManeuver: true,
    unloadLoadManeuver: true,
    loadManeuverIcon: 'L',
    unloadManeuverIcon: 'U',
    unloadLoadManeuverIcon: 'UL',
    tags: [{
      id: 312,
      color: '3D77F7',
      description: 'CERVEZA'
    }],
    windows: [{
      begin: 0,
      end: 2359
    }],
    appointments: []
  }]
};
exports.CleanRow = CleanRow;